import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=797a5134"
import script from "./brand.vue?vue&type=script&lang=js"
export * from "./brand.vue?vue&type=script&lang=js"
import style0 from "./brand.vue?vue&type=style&index=0&id=797a5134&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797a5134')) {
      api.createRecord('797a5134', component.options)
    } else {
      api.reload('797a5134', component.options)
    }
    module.hot.accept("./brand.vue?vue&type=template&id=797a5134", function () {
      api.rerender('797a5134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mall/brand.vue"
export default component.exports